import align from "./align";
import animation from "./animation";
import background from "./background";
import border from "./border";
import height from "./height";
import width from "./width";
import shadow from "./shadow";
import padding from "./padding";
import margin from "./margin";

export default [align, animation, background, border, height, width, shadow, padding, margin];
